import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
    <ScrollToTop />
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </ReactLenis>
);
